/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 10:50:01
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-04 17:29:28
 * @FilePath: /knit-web/src/locale/zh-CN/user-profile.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  workspaceSettings: {
    title: '设置',
    workspace: {
      editTitle: '编辑工作空间',
      name: '工作空间名称',
      namePlaceholder: '请输入工作空间名称',
      nameRequired: '请输入工作空间名称',
      description: '描述',
      descriptionPlaceholder: '请输入工作空间描述（可选）',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
    },
    members: {
      title: '成员',
      edit: '编辑',
      add: '添加',
      member: '成员',
      memberCount: '成员',
      joinedAt: '加入时间',
      actions: '操作',
      me: '我',
      owner: '所有者',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱地址',
      emailRequired: '请输入邮箱',
      inviteTitle: '邀请成员',
      inviteSuccess: '邀请成功',
      inviteFailed: '邀请失败',
      loadFailed: '加载成员列表失败',
      userNotFound: '未找到该用户',
      searchFailed: '搜索用户失败',
      pleaseSelectUser: '请先搜索并选择用户',
      invitationSent: '邀请已发送',
      invitationSentMessage:
        '邀请已发送到用户的应用内收件箱。请提醒他们查看消息。',
      backToSettings: '返回设置',
      inviteAnother: '邀请另一个',
      remove: '移除',
      removeTitle: '移除成员',
      removeMessage:
        '确定要移除此成员吗？他们将失去对工作空间所有资源的访问权限。',
      confirm: '确认',
      cancel: '取消',
      removeSuccess: '移除成功',
      removeFailed: '移除失败',
      leaveWorkspace: '离开工作空间',
      leaveWorkspaceTitle: '离开工作空间',
      leaveWorkspaceMessage:
        '确定要离开工作空间吗？你将失去对工作空间所有资源的访问权限。',
      leaveWorkspaceSuccess: '离开工作空间成功',
      leaveWorkspaceFailed: '离开工作空间失败',
    },
    resources: {
      title: '资源',
      desc: '管理您的资源',
      knowledge: '知识库',
      knowledgeDesc: '管理和使用知识库',
      nodeTemplate: '节点模板',
      nodeTemplateDesc: '管理和使用节点模板',
      prompt: 'Prompt模板',
      promptDesc: '管理和使用Prompt模板',
      example: '执行示例',
      exampleDesc: '管理和使用执行示例',
    },
    apiKey: {
      title: 'API Key',
      create: '创建 API Key',
      topTip:
        '为了防止 API 滥用，请保护好您的 API Key。删除后密钥将无法使用且无法恢复。',
      columns: {
        name: '名称',
        description: '描述',
        apiKey: 'API Key',
        runtimeResource: '运行资源',
        createdAt: '创建时间',
        createdBy: '创建人',
        lastUsed: '上次使用时间',
        never: '从不',
        actions: '操作',
      },
      actions: {
        edit: '编辑信息',
        copy: '复制 API Key',
        delete: '删除',
        deleteSuccess: '删除成功',
      },
      modal: {
        createTitle: '创建 API Key',
        editTitle: '编辑 API Key',
        name: 'API Key 名称',
        namePlaceholder: '请输入 API Key 名称',
        autoGenerated: '为空自动生成',
        required: '必填',
        createSuccess: '创建成功',
        description: 'API Key 描述',
        descriptionPlaceholder: '请输入 API Key 描述',
        secretTitle: 'API Key',
        secretNotice: '请将此密钥保存在安全且可访问的地方。',
        copy: '复制',
        copySuccess: '复制成功',
        save: '保存',
        cancel: '取消',
        close: '关闭',
      },
      deleteConfirm: {
        title: '删除密钥 "{name}"',
        contentUsedPrefix: '此 API Key 上次使用于 ',
        contentSuffix: '。删除它将立即撤销访问权限且无法撤销。',
        contentUnused:
          '此 API Key 尚未被使用。删除它将立即撤销访问权限且无法撤销。',
        confirm: '确认',
        cancel: '取消',
      },
      tips: {
        nameIncrement:
          '可按照该工作空间间的API key递增。如第一个API Key命名为API Key1。',
        descInfo: '仅作为用户标识该API Key的途径',
      },
    },
    menu: {
      members: '成员',
      resources: '资源',
      apiKey: 'API密钥',
      identifiers: '执行标识',
    },
    identifiers: {
      title: '执行标识',
      description:
        '执行标识代表了一个稳定的执行契约，将外部集成与工作流实现解耦。',
      create: '创建执行标识',
      column: {
        identifier: '执行标识',
        target: '目标',
        lastUsed: '最近使用',
        actions: '操作',
      },
      action: {
        editMeta: '编辑元数据',
        updateTarget: '更新目标',
        updateHistory: '更新历史',
        delete: '删除',
        open_target_workflow: '打开目标工作流',
      },
      message: {
        deleteConfirmTitle: '删除执行标识 "{name}"',
        deleteConfirmContentUsed:
          '该执行标识最后使用于 {date}。删除它将立即撤销访问权限且无法恢复。',
        deleteConfirmContentUnused:
          '该执行标识尚未被使用。删除它将立即撤销访问权限且无法恢复。',
        deleteSuccess: '删除成功',
        createdSuccess: '执行标识创建成功',
        updatedSuccess: '执行标识更新成功',
        targetUpdatedSuccess: '执行标识目标更新成功',
        confirm: '确认',
        cancel: '取消',
      },
      createModal: {
        title: '创建执行标识',
        name: '执行标识名称',
        namePlaceholder: '例如：login_reward',
        nameHelp:
          '工作空间内唯一。仅限字母、数字和下划线。必须以字母开头。创建后不可更改。',
        nameRequired: '请输入执行标识名称',
        namePattern: '必须以字母开头，且仅包含字母、数字和下划线',
        desc: '执行标识描述',
        descPlaceholder: '请输入执行标识描述',
      },
      editModal: {
        title: '编辑执行标识',
        nameTooltip: '创建后名称无法修改',
      },
      targetModal: {
        title: '更新执行标识',
        latestTarget: '当前目标',
        noTarget: '未选择目标',
        unknownWorkflow: '未知工作流',
        updateTo: '更新至',
        targetWorkflow: '目标工作流',
        selectWorkflow: '选择工作流',
        targetVersion: '目标版本',
        selectVersion: '选择版本',
        versionDesc: '版本描述',
        updatedAt: '更新于',
        by: '由',
        selectRequired: '请选择目标工作流和版本',
      },
      historyModal: {
        title: '更新历史',
        targetWorkflow: '目标工作流',
        targetVersion: '目标版本',
        updatedAt: '更新时间',
        updatedBy: '更新人',
      },
      never: '从未',
    },
  },
};
